import { NodesById } from '../../../types'

export const getAllCompanyIds = (nodesById: NodesById): string[] => {
  const companyIds: string[] = []
  for (const [, nodeData] of Object.entries(nodesById)) {
    if (nodeData.type === 'company' && nodeData.value) {
      companyIds.push(String(nodeData.value))
    }
  }
  return companyIds
}

export const findNodeCompanyId = (nodeId: string, nodesById: NodesById): string | null => {
  const findCompanyParent = (currentNodeId: string, visited: Set<string> = new Set()): string | null => {
    if (visited.has(currentNodeId)) return null
    visited.add(currentNodeId)

    const nodeData = nodesById[currentNodeId]
    if (!nodeData) return null

    if (nodeData.type === 'company') {
      return nodeData.value != null ? String(nodeData.value) : null
    }

    if (nodeData.parentId) {
      return findCompanyParent(nodeData.parentId, visited)
    }

    return null
  }

  return findCompanyParent(nodeId)
}
